var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeftSideDoubleArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_58383",
    "data-name": "Group 58383",
    xmlns: "http://www.w3.org/2000/svg",
    width: 9.143,
    height: 8.5,
    viewBox: "0 0 9.143 8.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape_-_Outline",
    "data-name": "Combined-Shape - Outline",
    d: "M4.25,0H4.241a.88.88,0,0,0-.183.021L4.032.028,4.008.035a.71.71,0,0,0-.088.03L3.9.073a.708.708,0,0,0-.082.04L3.784.135A.66.66,0,0,0,3.717.18a1.01,1.01,0,0,0-.1.087L.256,3.646a.878.878,0,0,0,.623,1.5.866.866,0,0,0,.62-.259L3.722,2.651l.528-.56.532.564L7,4.884A.877.877,0,0,0,8.244,3.646L4.872.259h0L4.867.254h0A.867.867,0,0,0,4.72.136L4.684.116A.7.7,0,0,0,4.6.073L4.583.066A.709.709,0,0,0,4.5.035L4.469.029,4.446.023a.634.634,0,0,0-.07-.014L4.326,0A.621.621,0,0,0,4.25,0Z",
    transform: "translate(4 8.5) rotate(-90)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape_-_Outline-2",
    "data-name": "Combined-Shape - Outline",
    d: "M4.25,0H4.241a.88.88,0,0,0-.183.021L4.032.028,4.008.035a.71.71,0,0,0-.088.03L3.9.073a.708.708,0,0,0-.082.04L3.784.135A.66.66,0,0,0,3.717.18a1.01,1.01,0,0,0-.1.087L.256,3.646a.878.878,0,0,0,.623,1.5.866.866,0,0,0,.62-.259L3.722,2.651l.528-.56.532.564L7,4.884A.877.877,0,0,0,8.244,3.646L4.872.259h0L4.867.254h0A.867.867,0,0,0,4.72.136L4.684.116A.7.7,0,0,0,4.6.073L4.583.066A.709.709,0,0,0,4.5.035L4.469.029,4.446.023a.634.634,0,0,0-.07-.014L4.326,0A.621.621,0,0,0,4.25,0Z",
    transform: "translate(0 8.5) rotate(-90)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftSideDoubleArrow);
export default __webpack_public_path__ + "static/media/LeftSideDoubleArrow.c5720231f924ba0a795f86fd6e75605b.svg";
export { ForwardRef as ReactComponent };